module.exports = __webpack_public_path__ + "img/1.94bc8782.jpg";